module.exports = __webpack_public_path__ + "static/media/Bgsplash.ce1c4130.png";